import { render, staticRenderFns } from "./Departmenttool.vue?vue&type=template&id=3871eb64"
import script from "./Departmenttool.vue?vue&type=script&lang=js"
export * from "./Departmenttool.vue?vue&type=script&lang=js"
import style0 from "./Departmenttool.vue?vue&type=style&index=0&id=3871eb64&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports